import React, { useState, useEffect } from "react";
// components
import AdminNavbar from "../components/CMS/Navbars/AdminNavbar.js";
import Sidebar from "../components/CMS/Sidebar/Sidebar.js";
import HeaderWithoutStats from "../components/CMS/Headers/HeaderWithoutStats.js";
import FooterAdmin from "../components/CMS/Footers/FooterAdmin.js";
import Table, { SelectColumnFilter, hasFeatured, formatDate, Action, projectBuildingType, projectBuildingStyle } from "../components/CMS/Table/ProjectTable.js";
import Loader from "../components/CMS/Loader/Loader.js";
import { VariableIcon } from "@heroicons/react/24/outline";

export default function Admin() {

  const token = localStorage.getItem("token");

  const data = [
    {
      "id": 1,
      "projectId": 1001,
      "projectDescription": "fox jumps over the lazy dogTh",
      "projectBuildingType": "Privat",
      "projectCoverImg": "realmedia.com",
      "projectDistrict": "YMT ",
      "projectArea": "HK",
      "projectAddress": "502 Foxrun Street Park Ridge, IL 60068",
      "projectBuildingStyle": "日系",
      "projectHouseSize": "-318144416.422",
      "projectHouseName": "Bertram",
      "projectBuildTime": "Thu Apr 03 20:19:34 CST 1997",
      "creationTime": "2004-06-01T16:03:58.346+00:00",
      "hasImgComparison": 0,
      "hasFeatured": 0,
      "isShow": 1
    },
  ]

  const [selectDate, setSelectDate] = useState(new Date());
  const [datax, setData] = useState(data);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  var userLogged = false;

  function validateLogin() {
    fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/cms/validate', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    })
      .then(response => {
        if (response.status == 200) {
          // console.log("is true")
        } else {
          window.location.href = '/cms/admin/login';
        }
        // console.log(response)

      })
      .catch((e) => {
        window.location.href = '/cms/admin/login';
      });
  }

  
  useEffect(() => {
    validateLogin();
    fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects')
      .then(response => response.json())
      .then((usefulData) => {
        usefulData.data.projectList.sort((a, b) => a.projectId - b.projectId);
        // console.log(usefulData.data.projectList);
        setLoading(false);
        setData(usefulData.data.projectList);
      })
      .catch((e) => {
        alert("發生錯誤, 請重新載入")
      });

  }, []);

  const columns = React.useMemo(() => [
    {
      Header: "項目名稱",
      accessor: 'projectHouseName',
    },
    {
      Header: "建築類型",
      accessor: 'projectBuildingType',
      Cell: projectBuildingType,
    },
    // remark
    {
      Header: "樓宇類型",
      accessor: 'projectBuildingStyle',
      Cell: projectBuildingStyle,
    },
    {
      Header: "精選",
      accessor: 'hasFeatured',
      Filter: SelectColumnFilter,
      Cell: hasFeatured,
    },
    {
      Header: "更改/隱藏",
      accessor: 'projectId',
      accessor: d => `${d.projectId} ${d.isShow}`,
      Cell: Action,
    }
  ], [])

    return (
      <>
        <Sidebar />
        <div className="relative md:ml-64 bg-blueGray-100">
          <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4">
            <div className="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
              {/* Brand */}
              <div
                className="text-white text-xl uppercase lg:inline-block font-semibold"
              >
                項目管理
              </div>

            </div>
          </nav>
          {/* Header */}
          <HeaderWithoutStats />
          <div className="px-4 md:px-10 ">
            <div className="">
              {
                (loading == true)
                  ? <Loader />
                  : <Table columns={columns} data={datax} />
              }
            </div>
            <FooterAdmin />
          </div>
        </div>
      </>
    );
  }

